<div>
    <a
    [routerLink]="getStreamUrl()"
    (click)="saveUrl()"
    ></a>

    <!-- дата начала, время для лайв START-->
    <div>
        <ng-container [ngSwitch]="match.status">
            <ng-template ngSwitchCase="live">
                    <span class="anim-prnt">
                        <ng-template [prematchAnimateValue]="liveState()" let-val>
                            <span class="orange">{{val}}&lrm;</span>
                        </ng-template>
                    </span>
            </ng-template>
            <ng-template ngSwitchDefault>
                <span class="grey">{{ match.start|date:'HH:mm':ofs}}</span>
                <span class="grey"> {{ match.start|date:'dd.MM':ofs}}</span>
            </ng-template>
        </ng-container>
    </div>
   <!-- дата начала, время для лайв END-->
   <div>
    <ng-container *ngIf="match.home">
        <span>
            <picture class="default-img translation__img-m" [xSrc]="'/onexbet/pk' + match.home.pk_id + '.png'" [default]="match.home.name"
                [xSrcset]="{'*': 'w=18,h=18,f=sd'}" [sSrcset]="{'*': 'w=36,h=36,f=sd'}"></picture>
            <span class="wrd-ell" dir="auto">{{match.home.name}}&lrm;</span>
        </span>
        <span *ngIf="match.away">
            <picture class="default-img translation__img-m" [xSrc]="'/onexbet/pk' + match.away.pk_id + '.png'"  [default]="match.away.name"
                     [xSrcset]="{'*': 'w=18,h=18,f=sd'}" [sSrcset]="{'*': 'w=36,h=36,f=sd'}"></picture>
            <span class="wrd-ell" dir="auto">{{match.away.name}}&lrm;</span>
        </span>
    </ng-container>
    <ng-container *ngIf="!match.home">
        <span dir="auto">{{match.name}}&lrm;</span>
    </ng-container>
</div>
<div [style]="match.status == 'not_started' ? 'z-index: 2' : ''">
    <ng-container [ngSwitch]="match.status">
        <ng-template ngSwitchCase="not_started">

                <ng-container *ngIf="match.odds?.b; else noLinkTmp">
                    <a [href]="concatLink(match.odds?.b?.url, match.odds?.u)" target="_blank" *ngFor="let odd of match.odds?.e">
                        <span i18n="Кэф в списке трансляций@@BROADCAST_LIST_ODDS_ITEM">
                            <span class="grey">{disStr(odd.type), select, W1 {W1} X {X} W2 {W2}}</span>
                            {{odd.oddsMarket | number : '1.2-2': 'en'}}
                            </span>
                            </a>
                            </ng-container>
                            <ng-template #noLinkTmp>
                                <span *ngFor="let odd of match.odds?.e"
                                      (click)="openModal(match.odds?.b)"
                                      [ngClass]="{link:match.odds?.b === null}">
                                    <span i18n="Кэф в списке трансляций@@BROADCAST_LIST_ODDS_ITEM">
                                        <span class="grey">{disStr(odd.type), select, W1 {W1} X {X} W2 {W2}}</span>
                                        {{odd.oddsMarket | number : '1.2-2': 'en'}}
                                    </span>
                                </span>
                            </ng-template>
        </ng-template>
        <ng-template ngSwitchDefault>
            <ng-container *ngFor="let m of match.score | score:sport.id;index as i; trackBy: trackByI">
                    <div *ngIf="m&&match.home&&match.away">
                        <span class="anim-prnt">
                            <ng-template [prematchAnimateValue]="m[match.home!.pk_id]" let-val>
                                <span [ngClass]="{orange:i===0}">
                                    {{val||0}}
                                    <sup *ngIf="m.tb">
                                        {{m.tb[match.home!.pk_id]}}
                                    </sup>
                                </span>
                            </ng-template>
                        </span>

                        <span class="anim-prnt">
                            <ng-template [prematchAnimateValue]="m[match.away!.pk_id]" let-val>
                                <span [ngClass]="{orange:i===0}">
                                    {{val||0}}
                                    <sup *ngIf="m.tb">
                                        {{m.tb[match.away!.pk_id]}}
                                    </sup>
                                </span>
                            </ng-template>
                        </span>
                    </div>
            </ng-container>
            <!-- чья подача,теннис -->
            <div class="srvng" *ngIf="match.score&&match.score.length>0&&match.score[0].serving">
                <span>
                    <span [ngClass]="{active:match.score[0].serving===match.home!.pk_id}"></span>
                </span>
                <span>
                    <span [ngClass]="{active:match.score[0].serving===match.away!.pk_id}"></span>
                </span>
            </div>
            <div class="ss" *ngIf="match.score&&match.score.length>0&&match.score[0].ss">
                <span class="anim-prnt">
                    <ng-template [prematchAnimateValue]="match.score[0].ss[match.home!.pk_id]" let-val>
                        <span class="orange">{{val||0}}</span>
                    </ng-template>
                </span>

                <span class="anim-prnt">
                    <ng-template [prematchAnimateValue]="match.score[0].ss[match.away!.pk_id]" let-val>
                        <span class="orange">{{val||0}}</span>
                    </ng-template>
                </span>
            </div>

        </ng-template>
    </ng-container>

</div>
</div>

<i class="translation__icon _icon-star-off"
 [ngClass]="{active:fs.isMatchExist(match.id)}"
 (click)="fs.isMatchExist(match.id)?fs.delMatch(match.id):fs.addMatch(match.id)"
 ></i>
